import { freeReadPath } from "src/configs/subscription-access";
import axios from "axios";

const { protocol, hostname, port } = window.location;
const backEndHostName =
  `${window.rich.env.BACKEND_HOST}` !== undefined &&
  `${window.rich.env.BACKEND_HOST}` !== ""
    ? `${window.rich.env.BACKEND_HOST}`
    : hostname;
const collectorHostName =
  `${window.rich.env.COLLECTOR_HOST}` !== undefined &&
  `${window.rich.env.COLLECTOR_HOST}` !== ""
    ? `${window.rich.env.COLLECTOR_HOST}`
    : hostname;

const isHttps = protocol === "https:";
const frontEndHost = `${protocol}//${hostname}`;
const backEndHost = `${protocol}//${backEndHostName}`;
const collectorHost = `${protocol}//${collectorHostName}`;

// HTTPS: 같은 호스트:포트에서 path prefix로 분기 (nginx 프록시)
// HTTP: 기존 방식 (포트로 분기)
const backEndPort =
  `${window.rich.env.BACKEND_PORT}` !== undefined
    ? `${window.rich.env.BACKEND_PORT}`
    : "8080";
const collectorPort =
  `${window.rich.env.COLLECTOR_PORT}` !== undefined
    ? `${window.rich.env.COLLECTOR_PORT}`
    : "8080";

const effectivePort = port && port !== "80" && port !== "443" ? `:${port}` : "";
export const frontEndUrl = `${frontEndHost}${effectivePort}`;
export const backEndUrl = isHttps
  ? `${frontEndUrl}/api/v1`
  : `${backEndHost}:${backEndPort}/api/v1`;
export const collectorUrl = isHttps
  ? `${frontEndUrl}/col/v1`
  : `${collectorHost}:${collectorPort}/api/v1`;

const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";

class TokenApi {
  getAccessToken() {
    return sessionStorage.getItem(ACCESS_TOKEN_KEY);
  }

  setAccessToken(token) {
    sessionStorage.setItem(ACCESS_TOKEN_KEY, token);
  }

  getRefreshToken() {
    return sessionStorage.getItem(REFRESH_TOKEN_KEY);
  }

  setRefreshToken(token) {
    return sessionStorage.setItem(REFRESH_TOKEN_KEY, token);
  }

  clearTokens() {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    sessionStorage.removeItem(REFRESH_TOKEN_KEY);
  }
}

class SessionStorage {
  getData(key) {
    return sessionStorage.getItem(key);
  }

  setData(key, value) {
    return sessionStorage.setItem(key, value);
  }

  deleteData(key) {
    sessionStorage.removeItem(key);
  }
}

export const tokenApi = new TokenApi();
export const storageApi = new SessionStorage();

export const backend = axios.create({
  baseURL: backEndUrl,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export const collector = axios.create({
  baseURL: collectorUrl,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

backend.interceptors.request.use((config) => ({
  ...config,
  url: freeReadPath(config.url, config.method),
}));
